import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Renders post body content. Tries Markdown first (paragraphs, headings,
 * blockquotes, lists, links, bold/italic). For plain text without markdown
 * the renderer still preserves line breaks as paragraphs.
 */
export default function MarkdownArticle({ children, className = "" }) {
  if (!children) return null;
  return (
    <div className={`prose-tavern ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
          img: ({ node, ...props }) => (
            <img {...props} loading="lazy" className="rounded-sm my-4 max-w-full h-auto" />
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
